import { render, staticRenderFns } from "./SidebarCreateNewUser.vue?vue&type=template&id=1ff51598&scoped=true"
import script from "./SidebarCreateNewUser.vue?vue&type=script&lang=js"
export * from "./SidebarCreateNewUser.vue?vue&type=script&lang=js"
import style0 from "./SidebarCreateNewUser.vue?vue&type=style&index=0&id=1ff51598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff51598",
  null
  
)

export default component.exports